import React from 'react';
import {
  BetStatus,
  convertAmount,
  exchangeAmountByRate,
  ListElemText,
  ListItem,
  ListItemCell,
  ListItemCont,
  ListItemRowLoader,
  maskName,
  useTranslation,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { BetTypeItem } from './betType';
import { roundsInfoStore } from '../../../store';

export const OtherBets = observer(({ data: bet }) => {
  const t = useTranslation();
  const { currentRoundId } = roundsInfoStore;

  return (
    <ListItemCont key={bet.id}>
      <ListItem active={bet.winAmount}>
        {currentRoundId !== bet.roundId && <ListItemRowLoader />}
        <ListItemCell>
          <ListElemText>{maskName(bet?.userId < 0 ? Math.abs(bet?.userId) : bet.userId)}</ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemText>{bet.freeBetId ? t('FREE_BET') : convertAmount(exchangeAmountByRate(bet).amount)}</ListElemText>
        </ListItemCell>
        <ListItemCell>
          <BetTypeItem bet={bet} />
        </ListItemCell>
        <ListItemCell>
          <ListElemText>
            {bet.status === BetStatus.Pending ? '...' : convertAmount(exchangeAmountByRate(bet).winAmount)}
          </ListElemText>
        </ListItemCell>
      </ListItem>
    </ListItemCont>
  );
});
